// Mock data for Crapule event website

export const eventInfo = {
  name: "CRAPULE",
  tagline: "Un soir où la cuisine rencontre le son",
  description: "Un thème, une ambiance, un rythme. Jamais deux fois la même.",
  concept: "Not a dinner. Not a party. Something in between...",
  currentVolume: {
    number: 3,
    theme: "Chargement…",
    date: "Chargement…",
    time: "",
    price: null, // Prix non défini pour le moment
    status: "upcoming", // upcoming, available, sold_out, past
    reservationsOpen: false
  },
  nextVolume: {
    number: 3,
    theme: "Chargement…",
    date: "Chargement…",
    time: "",
    price: null,
    status: "upcoming",
    reservationsOpen: false
  }
};

export const pastEvents = [
  {
    number: 1,
    theme: "MOUNTAIN TECHNO",
    date: "4 DÉCEMBRE 2025",
    time: "19H - 00H",
    price: 30,
    status: "past",
    description: "Notre première édition aux saveurs de Savoie",
    menu: {
      main: "Tartiflette Hors-Piste / Sauvage",
      dessert: "Panna Cotta au Génépi"
    },
    images: []
  }
];

export const upcomingEvents = [
  {
    number: 3,
    theme: "À DÉCOUVRIR",
    date: "PROCHAINEMENT",
    time: "",
    price: 0,
    status: "upcoming",
    description: "Un nouveau thème, de nouvelles saveurs...",
    reservationsOpen: false
  }
];

export const venue = {
  name: "Le Phare du Kanaal",
  address: "40, Quai des Charbonnages",
  city: "1080 Molenbeek",
  country: "Belgique",
  lat: 50.855,
  lng: 4.341,
  mapUrl: "https://www.google.com/maps/dir/?api=1&destination=40%20Quai%20des%20Charbonnages,%201080%20Molenbeek,%20Belgique"
};

export const menu = {
  volume: 1,
  theme: "Mountain Techno",
  dishes: [
    {
      id: 1,
      name: "La Tartiflette Hors-Piste",
      type: "main",
      vegetarian: false,
      ingredients: [
        "Pommes grenailles rôties",
        "Crème de Reblochon",
        "Lard confit au vin de Savoie",
        "Pickles d'échalotes"
      ]
    },
    {
      id: 2,
      name: "La Tartiflette Sauvage",
      type: "main",
      vegetarian: true,
      ingredients: [
        "Pommes grenailles rôties",
        "Crème de Reblochon",
        "Pleurotes confites au vin de Savoie",
        "Pickles d'échalotes"
      ]
    },
    {
      id: 3,
      name: "Panna Cotta au Génépi",
      type: "dessert",
      vegetarian: true,
      description: "Légère, froide, insolente"
    }
  ]
};

export const socialLinks = {
  instagram: "https://instagram.com/crapule_bxl",
  email: "contact@crapule.xyz"
};

export const reservations = [
  {
    id: "1",
    name: "Jean Dupont",
    email: "jean@example.com",
    phone: "+32 470 12 34 56",
    guests: 2,
    menuChoice: "meat",
    eventVolume: 2,
    status: "confirmed",
    createdAt: "2024-11-20T10:00:00Z"
  }
];
